import { useMutation, useQueryClient } from '@tanstack/react-query'
import * as orgsAPI from '@/api/orgsAPI'
import type { UUID } from 'crypto'

export function useUpdateProfileText() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: ({
      token,
      orgUuid,
      profileText,
      force,
    }: {
      token: string
      orgUuid: UUID
      profileText: string
      force?: boolean
    }) => orgsAPI.updateProfileText(token, orgUuid, profileText, force),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['currentOrgs'] })
    },
  })
}
